// Catalogs are stored under machine names like "VPAT_2.5-WCAG"; authors should see the
// ITI-style edition label instead (matching the acrType labels in useHyperlink.hook.js).
// Keyed by the edition code that follows the VPAT version — value is the display edition
// plus the headline standard(s) that edition covers.
const CATALOG_EDITIONS = {
  WCAG: { edition: "WCAG", standard: "WCAG 2.2" },
  508: { edition: "508", standard: "Revised Section 508" },
  EU: { edition: "EU", standard: "EN 301 549" },
  INT: { edition: "INT", standard: "WCAG 2.2, Revised Section 508, and EN 301 549" },
};

// "VPAT_2.5-WCAG" → ["2.5", "WCAG"]; tolerant of "_", "-", or spaces as separators.
const VPAT_NAME_PATTERN = /^VPAT[_\s]*([\d.]+)[-_\s]+(.+)$/i;

/**
 * Human-readable label for a catalog picker option, e.g.
 * "VPAT_2.5-WCAG" → "VPAT® 2.5 WCAG: WCAG 2.2".
 *
 * Falls back to the catalog's raw name/title (then id) when the name doesn't match the
 * expected VPAT pattern, so unrecognized catalogs still render something sensible.
 */
export default function formatCatalogLabel(catalog) {
  if (!catalog) return "";
  const rawName = String(catalog.name ?? catalog.title ?? catalog.label ?? "").trim();
  const fallback = rawName || String(catalog.id ?? catalog.catalog ?? "").trim();
  if (!rawName) return fallback;

  const match = rawName.match(VPAT_NAME_PATTERN);
  if (!match) return fallback;

  const version = (match[1] || String(catalog.vpatEdition ?? "")).trim();
  const editionCode = match[2].trim();
  const known = CATALOG_EDITIONS[editionCode.toUpperCase()];
  const editionLabel = known?.edition ?? editionCode;
  const base = version ? `VPAT® ${version} ${editionLabel}` : `VPAT® ${editionLabel}`;
  return known?.standard ? `${base}: ${known.standard}` : base;
}
